var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.$i18n.locale === "pe"
      ? _c(
          "div",
          [
            _c("Message", {
              attrs: {
                message: "",
                icon: "coming_soon_cl.svg",
                "as-card": true,
              },
            }),
          ],
          1
        )
      : _vm._e(),
    _vm.$i18n.locale === "br"
      ? _c(
          "div",
          [
            _c("Message", {
              attrs: {
                message: "",
                icon: "coming_soon_br.svg",
                "as-card": true,
              },
            }),
          ],
          1
        )
      : _vm._e(),
    _vm.$i18n.locale === "cl"
      ? _c(
          "div",
          [
            _c("InputParamsForm", {
              attrs: { "hide-params-button-id": "hide-params-button" },
              on: { send: _vm.onSend },
            }),
            _c("transition", { attrs: { name: "bounce" } }, [
              _vm.isLoading
                ? _c("div", { staticClass: "spinner-content" }, [
                    _c("div", { staticClass: "spinner" }, [
                      _c("div", { staticClass: "double-bounce1" }),
                      _c("div", { staticClass: "double-bounce2" }),
                    ]),
                  ])
                : _vm._e(),
            ]),
            _c("transition", { attrs: { name: "slide" } }, [
              _c("div", { class: [_vm.isResponseHidden ? "is-hidden" : ""] }, [
                _c(
                  "section",
                  {
                    staticClass: "section",
                    attrs: { id: "finance-params-table" },
                  },
                  [
                    _c("div", { staticClass: "box-content" }, [
                      _c("h4", [_vm._v(" Parámetros Financieros ")]),
                      _c(
                        "div",
                        { staticClass: "columns" },
                        _vm._l(_vm.financeParams, function (col, i) {
                          return _c(
                            "div",
                            { key: `col${i}`, staticClass: "column" },
                            [
                              _c(
                                "ul",
                                { staticClass: "finance-params-bullets" },
                                _vm._l(col, function (object, j) {
                                  return _c("li", { key: `row${i},${j}` }, [
                                    _c("b", [_vm._v(_vm._s(object.key) + ":")]),
                                    _vm._v(" " + _vm._s(object.value) + " "),
                                  ])
                                }),
                                0
                              ),
                            ]
                          )
                        }),
                        0
                      ),
                    ]),
                  ]
                ),
                _c(
                  "div",
                  { staticClass: "box-content" },
                  [
                    _c("Table", {
                      attrs: {
                        id: "amortization-schedule-table",
                        title: "Tabla de amortización",
                        "sticky-header": true,
                      },
                      model: {
                        value: _vm.amortizationSchedule,
                        callback: function ($$v) {
                          _vm.amortizationSchedule = $$v
                        },
                        expression: "amortizationSchedule",
                      },
                    }),
                  ],
                  1
                ),
              ]),
            ]),
            _c("transition", { attrs: { name: "slide" } }, [
              _vm.errorList.length > 0
                ? _c("div", { staticClass: "container" }, [
                    _c("article", { staticClass: "message is-danger" }, [
                      _c("div", { staticClass: "message-header" }, [
                        _c("p", [_vm._v("Error")]),
                      ]),
                      _c("div", { staticClass: "message-body" }, [
                        _c("p", [_vm._v("Revisa los siguientes campos:")]),
                        _c(
                          "ol",
                          _vm._l(_vm.errorList, function (item) {
                            return _c("li", { key: item }, [
                              _vm._v(" " + _vm._s(item) + " "),
                            ])
                          }),
                          0
                        ),
                      ]),
                    ]),
                  ])
                : _vm._e(),
            ]),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }